import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { Icon } from 'components/Icon';
import { PostListingLink } from 'components/Post/PostListingLink';
import { Text } from 'components/Text/Text';
import { trackClicked } from 'utils/analytics/track/trackClicked';

export function PageHeaderPostListingLink() {
  return (
    <PostListingLink
      onClick={() => {
        trackClicked('Post A Listing', {
          context: 'Header',
        });
      }}
    >
      <Box classes={['flex', 'align-center']}>
        <Box
          mr={[8, null, null, '4px']}
          opacity={0.8}
          alignItems="center"
          display="inline-flex"
        >
          {/* Mobile */}
          <Hide md lg xl display="inline-flex">
            <Icon name="pin" size={24} initialColorName="waterBlue" />
          </Hide>

          {/* Desktop */}
          <Hide xs sm display="inline-flex">
            <Icon name="pin" size={18} initialColorName="waterBlue" />
          </Hide>
        </Box>
        <Text fontSize="inherit" whiteSpace="nowrap">
          {getText('Post a Listing')}
        </Text>
      </Box>
    </PostListingLink>
  );
}
